import styled from 'styled-components';

export const PlayedDurationWrapper = styled.div`
  padding: 8px 12px 8px 0;
  min-width: 38px;
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  font-weight: 300;
  color: ${({ theme }) => theme.playedDurationColor};
  text-align: right;
  transition: color 0.2s ease-in-out;

  :hover {
    cursor: pointer;
    color: ${({ theme }) => theme.playedDurationColorHovered};
  }
`;
